/* KrutiKala search results + discovery
   Figma Make: src/components/search/SearchResultsGrid.tsx, SearchDiscovery.tsx */
(function () {
  'use strict';

  /* ── Results: sort, availability / price filters, load more ────────────
     Every matched product is rendered server-side; without JS they all
     stay visible. */
  function initResults(root) {
    const grid = root.querySelector('[data-kk-srch-grid]');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('[data-kk-srch-item]'));
    items.forEach((el, i) => {
      el.dataset.rank = String(i);
    });

    const perPage = parseInt(grid.dataset.perPage || '16', 10);
    const countEl = root.querySelector('[data-kk-srch-count]');
    const moreWrap = root.querySelector('[data-kk-srch-more-wrap]');
    const moreBtn = root.querySelector('[data-kk-srch-more]');
    const status = root.querySelector('[data-kk-srch-status]');
    const filterEmpty = root.querySelector('[data-kk-srch-filter-empty]');
    const forms = root.querySelectorAll('[data-kk-srch-filter-form]');
    const sortBtns = root.querySelectorAll('[data-kk-sort]');
    const sortLabels = root.querySelectorAll('[data-kk-srch-sort-label]');
    const clearBtns = root.querySelectorAll('[data-kk-srch-clear]');

    const state = { avail: [], min: null, max: null, sort: 'relevance', limit: perPage };

    const comparators = {
      relevance: (a, b) => a.dataset.rank - b.dataset.rank,
      'price-asc': (a, b) => a.dataset.price - b.dataset.price,
      'price-desc': (a, b) => b.dataset.price - a.dataset.price,
      'title-asc': (a, b) => a.dataset.title.localeCompare(b.dataset.title),
      'title-desc': (a, b) => b.dataset.title.localeCompare(a.dataset.title),
      newest: (a, b) => b.dataset.created - a.dataset.created,
    };

    function readForm(form) {
      state.avail = Array.from(form.querySelectorAll('input[name="kk_avail"]:checked')).map((i) => i.value);
      const min = parseFloat(form.querySelector('[name="kk_min"]')?.value);
      const max = parseFloat(form.querySelector('[name="kk_max"]')?.value);
      state.min = Number.isNaN(min) ? null : min;
      state.max = Number.isNaN(max) ? null : max;
    }

    function syncForms() {
      forms.forEach((form) => {
        form.querySelectorAll('input[name="kk_avail"]').forEach((input) => {
          input.checked = state.avail.includes(input.value);
        });
        const min = form.querySelector('[name="kk_min"]');
        const max = form.querySelector('[name="kk_max"]');
        if (min) min.value = state.min === null ? '' : state.min;
        if (max) max.value = state.max === null ? '' : state.max;
      });
    }

    function passes(el) {
      const price = Number(el.dataset.price) / 100;
      const available = el.dataset.available === 'true';
      if (state.avail.length === 1) {
        if (state.avail[0] === 'in' && !available) return false;
        if (state.avail[0] === 'out' && available) return false;
      }
      if (state.min !== null && price < state.min) return false;
      if (state.max !== null && price > state.max) return false;
      return true;
    }

    function render() {
      const sorted = items.slice().sort(comparators[state.sort] || comparators.relevance);
      sorted.forEach((el) => grid.appendChild(el));

      const visible = sorted.filter(passes);
      sorted.forEach((el) => {
        el.hidden = true;
      });
      visible.slice(0, state.limit).forEach((el) => {
        el.hidden = false;
      });

      const total = visible.length;
      const shown = Math.min(state.limit, total);
      if (countEl) {
        countEl.innerHTML = total + ' <span>' + (total === 1 ? 'creation' : 'creations') + '</span>';
      }
      if (moreWrap) moreWrap.hidden = shown >= total;
      if (status) status.textContent = 'Showing ' + shown + ' of ' + total + ' creations';
      if (filterEmpty) filterEmpty.hidden = total > 0;

      const active = state.avail.length + (state.min !== null ? 1 : 0) + (state.max !== null ? 1 : 0);
      root.querySelectorAll('.kk-srch-filters__head [data-kk-srch-clear]').forEach((btn) => {
        btn.hidden = active === 0;
      });
      root.querySelectorAll('[data-kk-srch-active-count]').forEach((el) => {
        el.textContent = active ? ' (' + active + ')' : '';
      });
    }

    function apply(form) {
      readForm(form);
      state.limit = perPage;
      syncForms();
      render();
    }

    forms.forEach((form) => {
      form.addEventListener('change', (event) => {
        if (event.target.name === 'kk_avail' && !form.closest('dialog')) apply(form);
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        apply(form);
        const dialog = form.closest('dialog');
        if (dialog) dialog.close();
      });
    });

    clearBtns.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        state.avail = [];
        state.min = null;
        state.max = null;
        state.limit = perPage;
        syncForms();
        render();
        const dialog = btn.closest('dialog');
        if (dialog) dialog.close();
      });
    });

    sortBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        state.sort = btn.dataset.kkSort;
        state.limit = perPage;
        sortBtns.forEach((b) => {
          b.setAttribute('aria-current', b.dataset.kkSort === state.sort ? 'true' : 'false');
        });
        sortLabels.forEach((label) => {
          label.textContent = btn.dataset.label || btn.textContent.trim();
        });
        const details = btn.closest('details');
        if (details) details.open = false;
        const dialog = btn.closest('dialog');
        if (dialog) dialog.close();
        render();
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', () => {
        state.limit += perPage;
        render();
      });
    }

    render();
  }

  /* ── Mobile filter / sort bottom sheets ─────────────────────────────── */
  function initSheets(root) {
    root.querySelectorAll('[data-kk-srch-sheet-open]').forEach((trigger) => {
      const sheet = root.querySelector('#' + trigger.dataset.kkSrchSheetOpen);
      if (!sheet) return;
      trigger.addEventListener('click', () => {
        if (typeof sheet.showModal === 'function') sheet.showModal();
        else sheet.setAttribute('open', '');
      });
    });

    root.querySelectorAll('[data-kk-srch-sheet-close]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const sheet = trigger.closest('dialog');
        if (sheet) sheet.close();
      });
    });
  }

  /* ── Sort dropdown: close on outside click / Escape ─────────────────── */
  function initSortDropdown(root) {
    const sort = root.querySelector('[data-kk-srch-sort]');
    if (!sort) return;

    document.addEventListener('click', (event) => {
      if (sort.open && !sort.contains(event.target)) sort.open = false;
    });

    sort.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        sort.open = false;
        const summary = sort.querySelector('summary');
        if (summary) summary.focus();
      }
    });
  }

  /* ── FAQ accordion ──────────────────────────────────────────────────── */
  function initFaq(root) {
    const items = root.querySelectorAll('[data-kk-disc-faq-item]');
    items.forEach((item) => {
      const btn = item.querySelector('.kk-disc-faq__btn');
      const body = item.querySelector('.kk-disc-faq__body');
      if (!btn || !body) return;

      body.hidden = btn.getAttribute('aria-expanded') !== 'true';

      btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        items.forEach((sibling) => {
          const sBtn = sibling.querySelector('.kk-disc-faq__btn');
          const sBody = sibling.querySelector('.kk-disc-faq__body');
          if (!sBtn || !sBody) return;
          sBtn.setAttribute('aria-expanded', 'false');
          sBody.hidden = true;
        });
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          body.hidden = false;
        }
      });
    });
  }

  /* ── Collapsible SEO copy ───────────────────────────────────────────── */
  function initSeo(root) {
    const toggle = root.querySelector('[data-kk-disc-seo-toggle]');
    const body = root.querySelector('[data-kk-disc-seo-body]');
    const more = root.querySelector('[data-kk-disc-seo-more]');
    if (!toggle || !body) return;

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      body.classList.toggle('is-open', open);
      if (more) more.hidden = open;
    }

    toggle.addEventListener('click', () => {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    if (more) more.addEventListener('click', () => setOpen(true));
  }

  /* Both sections load this file, and section reloads re-run init, so each
     root is only wired once. */
  function once(root, setup) {
    if (root.dataset.kkSearchBound === 'true') return;
    root.dataset.kkSearchBound = 'true';
    setup(root);
  }

  function init() {
    document.querySelectorAll('[data-kk-srch-root]').forEach((root) => {
      once(root, () => {
        initResults(root);
        initSheets(root);
        initSortDropdown(root);
      });
    });
    document.querySelectorAll('[data-kk-disc-root]').forEach((root) => {
      once(root, () => {
        initFaq(root);
        initSeo(root);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
